import React from "react";
import checkmarkImg from '../../images/check-mark.png';
import "./feature-content.css";

function FeatureContent({ feature }) {
  return (
    <>
      <h4 className="feat-title">
        {feature.title()}
      </h4>
      <ul className="feat-description">
        {feature.items.map((item, index)  => (
           <li className="flex items-center feat-item" key={index}>
           <img src={checkmarkImg} alt={checkmarkImg} className="feat-checkmark" /> {item}
         </li>
        ))}
      </ul>
    </>
  );
}

export default FeatureContent;
